import { Dialog } from '@mui/material';
import { AddSeller } from './AddSeller';

export function AddSellerDialog(props: {
  open: boolean;
  handleClose: () => void;
}) {
  return (
    <Dialog open={props.open} onClose={props.handleClose}>
      <AddSeller {...props} />
    </Dialog>
  );
}
